module.exports = __webpack_public_path__ + "img/title-en.761eb76e.webp";